import Card from "components/card";

const Widget = ({ icon, title, subtitle, secondTitle, secondSubtitle, thirdTitle, thirdSubtitle, caption, iconBg }) => {
  return (
    <Card extra="flex-grow items-center rounded-[20px] p-4 text-center transition-shadow duration-200 hover:shadow-lg">
      <div className="rounded-full p-3.5" style={{ backgroundColor: iconBg }}>
        <span className="flex items-center text-white">
          {icon}
        </span>
      </div>

      <div className="mt-3 flex flex-col items-center">
        <p className="font-dm text-xs xl:text-sm font-medium text-gray-600">{title}</p>
        <h4 className="text-2xl font-bold text-navy-700 dark:text-white">{subtitle}</h4>
      </div>

      {(secondTitle || thirdTitle) && (
        <div className="mt-3 flex w-full items-center justify-center gap-6 border-t border-gray-100 pt-3 dark:border-white/10">
          <div className="flex flex-col items-center">
            <p className="font-dm text-[10px] font-medium text-gray-600">{secondTitle}</p>
            <h4 className="text-sm font-bold text-navy-700 dark:text-white">{secondSubtitle}</h4>
          </div>

          <div className="flex flex-col items-center">
            <p className="font-dm text-[10px] font-medium text-gray-600">{thirdTitle}</p>
            <h4 className="text-sm font-bold text-navy-700 dark:text-white">{thirdSubtitle}</h4>
          </div>
        </div>
      )}

      {caption && !secondTitle && !thirdTitle && (
        <div className="mt-3 w-full border-t border-gray-100 pt-3 dark:border-white/10">
          <p className="font-dm text-sm font-medium text-gray-600">{caption}</p>
        </div>
      )}
    </Card>
  );
};

export default Widget;
